import { useEffect, useRef } from 'react';

/**
 * Fires `callback` whenever `value` changes between renders.
 *
 * The callback is not called on mount; only subsequent changes trigger it.
 *
 * @example
 * useOnChange(isVerified, () => refresh());
 */
export const useOnChange = <T>(
  value: T,
  callback: (() => void) | undefined
): void => {
  const previousRef = useRef<T>(value);

  useEffect(() => {
    const previous = previousRef.current;
    previousRef.current = value;
    if (previous !== value) {
      callback?.();
    }
  }, [value, callback]);
};
